import { Button, MenuItem, Select, TextField } from '@mui/material'
import React from 'react'
import { getProfileFieldValues, profileRecordsConditions, useAdvancedSearchStore } from '../hooks/useAdvancedSearch'

const ProfileRecordRow = ({ filterIndex }) => {
    const filterRow = useAdvancedSearchStore(s => s.appliedProfileRecords?.[filterIndex])
    const profileRecords = useAdvancedSearchStore(s => s.profileRecords)
    const modifyAppliedProfileRecord = useAdvancedSearchStore(s => s.modifyAppliedProfileRecord)
    const changeAddNewProfileRecord = useAdvancedSearchStore(s => s.changeAddNewProfileRecord)

    const { field, condition, value, type } = filterRow || {}

    if (!filterRow) return <></>

    return (
        <div className='flex flex-1 [&>div]:w-[33.33%] mb-5 space-x-4'>
            {field !== undefined && <div className='flex'>
                <Select
                    fullWidth
                    value={field}
                    MenuProps={{
                        style: { zIndex: 35001 }
                    }}
                    onChange={(e) => {
                        modifyAppliedProfileRecord(filterIndex, 'field', e.target.value)

                        modifyAppliedProfileRecord(filterIndex, 'condition', "")
                        const child = profileRecords.find((item) => item.value === e.target.value)
                        if (child) {
                            modifyAppliedProfileRecord(filterIndex, 'type', child.type)
                        } else {
                            modifyAppliedProfileRecord(filterIndex, 'type', "text")
                        }
                    }}
                >
                    {profileRecords.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </div>}
            {condition !== undefined ? <div>
                <Select
                    fullWidth
                    value={condition}
                    MenuProps={{
                        style: { zIndex: 35001 }
                    }}
                    onChange={(e) => {
                        modifyAppliedProfileRecord(filterIndex, 'condition', e.target.value)
                        modifyAppliedProfileRecord(filterIndex, 'value', "")
                        changeAddNewProfileRecord(true)
                    }}
                >
                    {profileRecordsConditions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </div> : <div className='w-full' />}
            {value !== undefined ? <div>
                {type === "text" && <TextField

                    fullWidth
                    value={value}
                    onChange={(e) => {
                        modifyAppliedProfileRecord(filterIndex, 'value', e.target.value)
                    }}

                />}
                {type === "date" && <TextField
                    fullWidth
                    value={value}
                    type='date'
                    onChange={(e) => {
                        modifyAppliedProfileRecord(filterIndex, 'value', e.target.value)
                    }}

                />}
                {type === "dropdown" && <Select
                    fullWidth
                    MenuProps={{
                        style: { zIndex: 35001 }
                    }}
                    value={value}
                    onChange={(e) => {
                        modifyAppliedProfileRecord(filterIndex, 'value', e.target.value)
                    }}
                >
                    {getProfileFieldValues(field).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>}
            </div> : <div className='w-full' />}
        </div>
    )
}

function ProfileRecordsFilter() {
    const appliedProfileRecordFilters = useAdvancedSearchStore(s => s.appliedProfileRecords)
    const addNewAppliedProfileRecord = useAdvancedSearchStore(s => s.addNewAppliedProfileRecord)
    const canAddNewProfileRecord = useAdvancedSearchStore(s => s.canAddNewProfileRecord)

    return (
        <div className='mx-[50px]'>
            <div className='flex flex-1 [&>div]:w-[33.33%] space-x-4'>
                <div>
                    <span>Profile Record</span>
                </div>
                <div>
                    <span>Condition</span>
                </div>
                <div>
                    <span>Filter</span>
                </div>
            </div>
            <div className='mt-5'>
                {
                    appliedProfileRecordFilters.map((_, index) => (
                        <ProfileRecordRow key={index} filterIndex={index} />
                    ))
                }
            </div>
            <div className='mt-5'>
                <Button disabled={!canAddNewProfileRecord} variant='contained' className='bg-secondary-500 hover:bg-secondary-500' onClick={addNewAppliedProfileRecord}>
                    Add new filter
                </Button>
            </div>
        </div>
    )
}

export default ProfileRecordsFilter